import React from 'react';
import { withStyles, Typography, Dialog, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';

const styles = theme => ({
    root: {},
    planName: {
        marginLeft: '12px',
        color: '#404040',
        marginTop: '6px',
        textAlign: 'center'
    },
    planDescription: { margin: '15px', textAlign: 'left', color: '#404040' },
    tableCell: {
        paddingLeft: theme.spacing(2),
        fontSize: '90%',
        padding: 0,
        height: "35px",
    },
    "@global": {
        "[class*='chipActive']": {
            color: theme.palette.success.dark
        },
        "[class*='chipPrepared']": {
            color: theme.palette.warning.dark
        },
        "[class*='chipInactive']": {
            color: theme.palette.error.dark
        },
    },
    chipActive: {
        color: theme.palette.success.dark,
    },
    chipPrepared: {
        color: theme.palette.warning.dark,
    },
    chipInactive: {
        color: theme.palette.error.dark,
    },
    tableDiv: {
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(0.1),
        margin: theme.spacing(0.25),
    },
    plan: {
        minWidth: '100px',
        float: 'center',
        margin: '15px'
    },
    subheading: {
        marginTop: '3px',
        paddingBottom: 0,
        marginBottom: 0,
        textAlign: 'center',
        color: '#404040'
    },
    tableRow: {
        fontSize: '100%',
    },
    newCel: {
        backgroundColor: '#F8F8F8',
        padding: 0,
        height: "35px",
        paddingLeft: 15,
        fontSize: '90%'
    },
    typeRow: {
        paddingLeft: 15,
        fontSize: '90%'
    },
    tableBody: {
        paddingTop: theme.spacing(0.5),
    }
});

const InfoDialog = props => {
    const { classes, translations, infoPlans, open, handleClose } = props;

    const planList = (rowsForType, type, className) =>
        rowsForType?.length > 0 && <>
            <TableRow className={classes.tableBody}>
                <TableCell rowSpan={rowsForType.length + 1} className={className}>{translations[type?.toLowerCase()?.replaceAll(' ', '_')] || type}</TableCell>
            </TableRow>
                {
                    rowsForType?.map((row, index) => (
                        <TableRow className={classes.tableBody} key={`${index}${row.from}`}>
                            <TableCell className={className}>{row.from}</TableCell>
                            <TableCell className={className}>{row.to}</TableCell>
                            <TableCell className={className}>{row.price}</TableCell>
                        </TableRow>
                        )
                    )
                }
        </>


    return (
        <div className={classes.root}>
            <Dialog
                open={open}
                disableBackdropClick={false}
                disableEscapeKeyDown={false}
                disableEnforceFocus={false}
                fullWidth={true}
                onClose={handleClose}
            >
                <div className={classes.planName}><h2>{infoPlans.name}</h2></div>
                <Typography className={classes.planDescription} key={'description'}>{infoPlans?.description}</Typography>
                <Divider variant="middle" />
                <div className={classes.plan}>{(infoPlans?.data || []).map(plan => <Typography key={plan}> {plan}</Typography>)}</div>
                <Divider variant="middle" />

                <div className={classes.subheading}><h3>{translations['price_list'] || 'Price list'}</h3></div>
                <div className={classes.tableDiv}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow className={classes.tableRow}>
                                <TableCell>{translations['type'] || 'Type'}</TableCell>
                                <TableCell>{translations['from' || 'From']}</TableCell>
                                <TableCell>{translations['to' || 'To']}</TableCell>
                                <TableCell>{translations['price' || 'Price']}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {planList(infoPlans?.priceList?.mobile || null, "Mobile Erasure", classes.newCel)}
                            {planList(infoPlans?.priceList?.mobile_erasure_lite || null, "Mobile Erasure Lite", classes.newCel)}
                            {planList(infoPlans?.priceList?.mobile_verifier || null, "Mobile Erasure Verification", classes.newCel)}
                            {planList(infoPlans?.priceList?.mobile_diagnose || null, "Mobile Diagnose", classes.newCel)}
                            {planList(infoPlans?.priceList?.mobile_check || null, "Mobile Check", classes.newCel)}
                            {planList(infoPlans?.priceList?.work || null, "Work Erasure", classes.newCel)}
                            {planList(infoPlans?.priceList?.work_verifier || null, "Work Erasure Verification", classes.newCel)}
                            {planList(infoPlans?.priceList?.work_diagnose || null, "Work Diagnose", classes.newCel)}
                            {planList(infoPlans?.priceList?.work_check || null, "Work Check", classes.newCel)}
                            {planList(infoPlans?.priceList?.remote || null, "Remote", classes.newCel)}
                        </TableBody>
                    </Table>
                </div>
            </Dialog>
        </div >
    );
}

export default withStyles(styles, { withTheme: true })(InfoDialog);